import { httpV1 as http } from '../api';

export async function saveGoals(data) {
  return http
    .post('/goals', data)
    .then(({ data }) => data);
}

export async function editGoals(data, id) {
  return http
    .patch(`/goals/${id}`, data)
    .then(({ data }) => data);
}

export async function getGoals({ product_id, params }) {
  return http
    .get(`/goals/product/${product_id}`, { params })
    .then(({ data }) => data);
}

export async function getGoalActive({ product_id, params }) {
  return http
    .get(`/goals/product/${product_id}/active`, { params })
    .then(({ data }) => data);
}

export async function getGoalById(id) {
  return http
    .get(`/goals/${id}`)
    .then(({ data }) => data);
}
